const IMAGE_EXTS = new Set(["png", "jpg", "jpeg", "gif", "webp", "svg", "bmp", "avif"]);
const CODE_LANG: Record<string, string> = {
  js: "javascript",
  jsx: "javascript",
  ts: "typescript",
  tsx: "typescript",
  py: "python",
  java: "java",
  c: "c",
  h: "c",
  cpp: "cpp",
  cc: "cpp",
  cs: "csharp",
  go: "go",
  rs: "rust",
  rb: "ruby",
  php: "php",
  html: "xml",
  xml: "xml",
  css: "css",
  scss: "scss",
  json: "json",
  yaml: "yaml",
  yml: "yaml",
  md: "markdown",
  sql: "sql",
  sh: "bash",
  bash: "bash",
  kt: "kotlin",
  swift: "swift",
  txt: "plaintext",
};

export const MAX_PREVIEW_BYTES = 512 * 1024;

function ext(name: string): string {
  const i = name.lastIndexOf(".");
  return i >= 0 ? name.slice(i + 1).toLowerCase() : "";
}

export function isImageFile(name: string): boolean {
  return IMAGE_EXTS.has(ext(name));
}

export function isCodeFile(name: string): boolean {
  return ext(name) in CODE_LANG;
}

export function isPreviewable(name: string): boolean {
  return isImageFile(name) || isCodeFile(name);
}

/** highlight.js language id for a filename, or undefined to auto-detect. */
export function codeLanguage(name: string): string | undefined {
  return CODE_LANG[ext(name)];
}
